namespace TabAurous.Production {
    export interface JobWorkReceiptItemsRow {
        TransItemId?: number;
        TransId?: number;
        TransDate?: string;
        VoucherTypeId?: number;
        VoucherNo?: string;
        OrderTypeId?: number;
        OrderTransId?: number;
        OrderTransItemId?: number;
        ProductId?: number;
        ProductCode?: string;
        OrderNo?: string;
        CustomerName?: string;
        AttributeId?: number;
        Attribute?: string;
        BagNo?: string;
        LotNo?: string;
        SubBagNo?: number;
        Line_No?: number;
        FromPieces?: number;
        FromWeight?: number;
        FromNetWeight?: number;
        Parts?: number;
        Purity?: number;
        PureWeight?: number;
        CompanyId?: number;
        FinancialYearId?: number;
        UserId?: number;
        FromDeptId?: number;
        StockAllocation?: boolean;
        FromWorkerId?: number;
        MetalId?: number;
        KaratId?: number;
        LossPercent?: number;
        Loss?: number;
        RefVoucherId?: number;
        RefTransId?: number;
        RefTransItemId?: number;
        StartDateTime?: string;
        EndDateTime?: string;
        DepartmentId?: number;
        BOMDetails?: JobWorkReceiptBOMRow[];
        NewBOMDetails?: Purchase.MaterialInItemsRow[];
        LaborDetails?: JobWorkReceiptLaborRow[];
        QualityInspection?: JWReceiptInspectionValuesRow[];
        QualityInspectionValue?: boolean;
        ProcessId?: number;
        TreeId?: number;
        TreeItemId?: number;
        TreeNo?: string;
    }

    export namespace JobWorkReceiptItemsRow {
        export const idProperty = 'TransItemId';
        export const nameProperty = 'BagNo';
        export const localTextPrefix = 'Production.JobWorkReceiptItems';
        export const deletePermission = 'Production:JobWorkReceipt:Delete';
        export const insertPermission = 'Production:JobWorkReceipt:Add';
        export const readPermission = '*';
        export const updatePermission = 'Production:JobWorkReceipt:Edit';

        export declare const enum Fields {
            TransItemId = "TransItemId",
            TransId = "TransId",
            TransDate = "TransDate",
            VoucherTypeId = "VoucherTypeId",
            VoucherNo = "VoucherNo",
            OrderTypeId = "OrderTypeId",
            OrderTransId = "OrderTransId",
            OrderTransItemId = "OrderTransItemId",
            ProductId = "ProductId",
            ProductCode = "ProductCode",
            OrderNo = "OrderNo",
            CustomerName = "CustomerName",
            AttributeId = "AttributeId",
            Attribute = "Attribute",
            BagNo = "BagNo",
            LotNo = "LotNo",
            SubBagNo = "SubBagNo",
            Line_No = "Line_No",
            FromPieces = "FromPieces",
            FromWeight = "FromWeight",
            FromNetWeight = "FromNetWeight",
            Parts = "Parts",
            Purity = "Purity",
            PureWeight = "PureWeight",
            CompanyId = "CompanyId",
            FinancialYearId = "FinancialYearId",
            UserId = "UserId",
            FromDeptId = "FromDeptId",
            StockAllocation = "StockAllocation",
            FromWorkerId = "FromWorkerId",
            MetalId = "MetalId",
            KaratId = "KaratId",
            LossPercent = "LossPercent",
            Loss = "Loss",
            RefVoucherId = "RefVoucherId",
            RefTransId = "RefTransId",
            RefTransItemId = "RefTransItemId",
            StartDateTime = "StartDateTime",
            EndDateTime = "EndDateTime",
            DepartmentId = "DepartmentId",
            BOMDetails = "BOMDetails",
            NewBOMDetails = "NewBOMDetails",
            LaborDetails = "LaborDetails",
            QualityInspection = "QualityInspection",
            QualityInspectionValue = "QualityInspectionValue",
            ProcessId = "ProcessId",
            TreeId = "TreeId",
            TreeItemId = "TreeItemId",
            TreeNo = "TreeNo"
        }
    }
}
